// Inline validation controller for admin user create/edit forms.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "firstName",
    "lastName",
    "email",
    "role",
    "submit"
  ]

  connect() {
    this.validate()
  }

  validate() {
    const firstNameValid = this.firstNameTarget.value.trim() !== ""
    const lastNameValid  = this.lastNameTarget.value.trim() !== ""
    const roleValid      = this.roleTarget.value !== ""
    const emailValid     = this.validEmail(this.emailTarget.value)

    this.toggleField(this.firstNameTarget, firstNameValid)
    this.toggleField(this.lastNameTarget, lastNameValid)
    this.toggleField(this.emailTarget, emailValid)
    this.toggleField(this.roleTarget, roleValid)

    this.submitTarget.disabled = !(
      firstNameValid &&
      lastNameValid &&
      emailValid &&
      roleValid
    )
  }

  toggleField(field, valid) {
    field.classList.toggle("is-invalid", !valid)
    field.classList.toggle("is-valid", valid)
  }

  validEmail(value) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)
  }
}
